<script setup>
    // Component
    import MainHeader from '@/components/HeaderComponent.vue';
    import Utils from '@/commonProject/helpers/utils.js';

    // Store
    import { useCommonStore } from '@/stores/common/commonStore';
    import { useReserveStore } from '@/stores/reserve/reserveStore';
    import { useLanguageStore } from '@/stores/common/languageStore';

    // Vue
    import { onMounted, reactive, ref, inject } from 'vue';
    import { useRouter } from 'vue-router';
    import { getCurrentInstance } from 'vue';

    // メッセージダイアログ取得。
    const { messageDialog } = inject('messageDialogKey');

    // Model
    // import { IssueServiceRequest } from '@/models/reserve/reservePlanningModel';

    // ----------------------------
    // 定数
    // ----------------------------
    const router = useRouter();
    const commonStore = useCommonStore();
    const reserveStore = useReserveStore();
    const languageStore = useLanguageStore();

    const app = getCurrentInstance();
    const API_URL = app.appContext.config.globalProperties.$constProperties.BASE_API_URL_S;

    // ----------------------------
    // リアクティブ変数
    // ----------------------------
    const serviceList = ref([]);
    const requestData = reactive(reserveStore.rsvdtlRequest);
    // const issueServiceRequest = reactive(new IssueServiceRequest());

    // ----------------------------
    // 関数
    // ----------------------------
    // 戻るボタン押下時
    function onBack() {
        // 前画面からの戻るフラグを有効にする。
        commonStore.reservePageBack = true;

        //router.back();
        // 相談内容から予約画面に戻す。
        router.push({ name: 'reserveplanningconsultation' });
    }
    // 進むボタン押下時
    async function onAdvance() {
        // 前画面からの戻るフラグを初期化する。
        commonStore.reservePageBack = false;

        const queryParam = {
            Lang: languageStore.getLanguageValue,
            ServicePk: requestData.ServicePk,
        };
        // サービス詳細取得API
        const response = await reserveStore.getServiceDetailAction(API_URL, queryParam);
        if (!response.success) {
            messageDialog('error', response.errorMessage);
            if (response.redirect) {
                location.href = response.redirectUrl;
            }
            return false;
        } else {
            // 取得した情報をStoreに格納する。
            reserveStore.setRsvdtlRequestData(requestData);

            // 規定PKが存在するので同意画面へ遷移する。
            requestData.RegulationPk = reserveStore.serviceDetail.RegulationPk;

            if (Utils.isNullEmpty(reserveStore.serviceDetail.RegulationPk)) {
                // 規定PKがない場合
                router.push('/reserve/planning/counselor');
            } else {
                // 規定PKがある場合
                commonStore.setFrom('consultation');
                router.push({ name: 'reserveplanningagree' });
            }
        }
    }

    // ----------------------------
    // ライフサイクル
    // ----------------------------
    onMounted(async () => {
        // 前画面から戻ってきたか判定する。
        if (!commonStore.reservePageBack) {
            // サービスの選択状況の初期化
            requestData.ServicePk = '';
        }

        // サービス一覧
        serviceList.value = reserveStore.serviceList;

        // 前画面からの戻るフラグを初期化する。
        commonStore.reservePageBack = false;

        // 戻り先座標を記録する。
        // 遷移元予約画面のルートと、設定・選択状況に応じて、戻る画面を制御する。
        // 相談内容を選んで予約のルート
        reserveStore.reserveStep.consultation.reserveplanningservice = true;

        // 前回の内容を復元した内容の場合
        // if (!reserveStore.restoreFlag) {
        //     requestData.ServicePk = reserveStore.reserveDetail.ServicePk;
        //     const queryParam = {
        //         Lang: languageStore.getLanguageValue,
        //         ServicePk: requestData.ServicePk,
        //     };
        //     // サービス詳細取得API
        //     const response = await reserveStore.getServiceDetailAction(API_URL, queryParam);
        //     if (!response.success) {
        //         messageDialog('error', response.errorMessage);
        //         if (response.redirect) {
        //             location.href = response.redirectUrl;
        //         }
        //         return false;
        //     } else {
        //         router.push('/reserve/planning/counselor');
        //     }
        // }
    });
</script>

<template>
    <section id="main">
        <MainHeader />
        <div id="contents">
            <div class="whiteBox">
                <h3 class="reserve">
                    <span>{{ $t('reservePlanningService.parts.pageTitle1') }}</span>
                    <!-- ステップ表示 -->
                    <template v-if="languageStore.getLanguageValue === '1'">
                        <img src="/img/step/mode1_step2.png" class="step" width="410" height="46" />
                    </template>
                    <template v-else>
                        <img src="/img/step/mode1_step2_en.png" class="step" width="410" height="46" />
                    </template>
                </h3>
                <section class="whiteBoxContents">
                    <p class="pageInfo">{{ $t('reservePlanningService.parts.pageInformation1') }}</p>
                    <!-- ステップ表示 -->
                    <template v-if="languageStore.getLanguageValue === '1'">
                        <img src="/img/step/mode1_step2.png" class="step" width="410" height="46" />
                    </template>
                    <template v-else>
                        <img src="/img/step/mode1_step2_en.png" class="step" width="410" height="46" />
                    </template>
                    <ul class="serviceList marginBottom15">
                        <li v-for="service in serviceList" :key="service.ServiceId">
                            <input type="radio" :id="'radio' + service.ServiceId" name="selectedServiceList" :value="service.ServicePk" v-model="requestData.ServicePk" />
                            <label :for="'radio' + service.ServiceId">
                                <ul class="serviceData">
                                    <li>
                                        <!--サービス名-->
                                        <span>{{ service.ServiceNm }}</span>
                                    </li>
                                    <li>
                                        <!--サービス説明-->
                                        <span>{{ service.ServiceExp }}</span>
                                    </li>
                                </ul>
                            </label>
                        </li>
                    </ul>
                </section>
                <section class="whiteBoxFooter">
                    <ul class="btnArea center">
                        <li>
                            <!--戻る-->
                            <button type="button" class="btnNormal" @click="onBack">{{ $t('common.parts.backPage') }}</button>
                        </li>
                        <li>
                            <!--進む-->
                            <button type="button" class="btnPrimary" @click="onAdvance" :disabled="!requestData.ServicePk">{{ $t('common.parts.nextPage') }}</button>
                        </li>
                    </ul>
                </section>
            </div>
        </div>
    </section>
</template>

<style></style>
